// eslint-disable-next-line import/prefer-default-export
export enum ROLE {
    GUEST = 'ROLE_GUEST',
    ADMINISTRATOR = 'ROLE_ADMINISTRATOR',
    PLANNING = 'ROLE_PLANNING',
    EPLANNING = 'ROLE_EPLANNING',
    PRODUCTION = 'ROLE_PRODUCTION',
    ASSEMBLY = 'ROLE_ASSEMBLY',
    EASSEMBLY = 'ROLE_EASSEMBLY'
}
